if (typeof ShippingNotice !== 'function') {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    init() {
      // Detect country and set the free shipping threshold
      const country = Shopify?.country || 'US'; // Default to US if not detected
      const freeShippingThreshold = country === 'CA' ? 120 : 120; // $99 for Canada, $120 for others

      // Fetch the cart total from the attribute (already in cents)
      const cartTotalCents = Number(this.getAttribute('data-cart-total-amount'));

      // Ensure valid cart total
      if (isNaN(cartTotalCents)) {
        console.error('Invalid cart total.');
        return;
      }

      // Get Shopify Currency Symbol
      const currencySymbol = Shopify?.currency?.symbol || '$';

      // Convert values (cart total from cents to dollars)
      const cartTotal = cartTotalCents / 100;
      const freeShippingRemaining = freeShippingThreshold - cartTotal;

      let shippingMessage = '';
      let shippingSuccess = false;
      
      // Calculate the progress percentage (ensure it doesn't exceed 100%)
      const progressPercentage = Math.min((cartTotal / freeShippingThreshold) * 100, 100);

      // Set the appropriate message
      if (freeShippingRemaining > 0) {
        shippingMessage = `
          <span class="shipping-text">You're <strong>${this._formatMoney(freeShippingRemaining, currencySymbol)}</strong> away from FREE SHIPPING!</span>
        `;
      } else {
        shippingMessage = `
          <span class="shipping-text shipping-text-success">🎉Congrats! You've unlocked <strong>FREE SHIPPING!</strong></span>
        `;
        shippingSuccess = true;
      }

      // Render the full message and progress bar
      this.innerHTML = `
        <div class="shipping-notice-container">
          <div class="alert alert--wide ship-bar">
            ${shippingMessage}
          </div>
          <div class="free-shipping-progress-container">
            <div class="free-shipping-progress-bar">
              <div class="progress-bar-fill" style="width: ${progressPercentage}%"></div>
            </div>
          </div>
          <div class="shipping-text shipping-text-success">
            Shipping rates may apply to select postal codes.
          </div>
          
        </div>
      `;
    }

    _formatMoney(amount, currencySymbol) {
      amount = Number(amount);
      return currencySymbol + (amount % 1 === 0 ? amount.toFixed(0) : amount.toFixed(2));
    }

  }

  if (typeof customElements.get('shipping-notice') == 'undefined') {
    customElements.define('shipping-notice', ShippingNotice);
  }

}